import { withCustomStyles } from 'src/hoc/withCustomStyles';
import { PickerLoadingContent } from '../../picker-loading-content/PickerLoadingContent';
import { styles } from './PickerGooglePhotoLoadingContent.styles';
import { PickerLoadingContentProps } from '../../picker-loading-content/PickerLoadingContent.types';

export const PickerGooglePhotoLoadingContent = withCustomStyles<{}, PickerLoadingContentProps['customStyles']>(
  PickerLoadingContent,
  styles,
);
